import { patchUser } from '../../services/user';
import { AppDispatch } from '../configureStore';
import signOutAction from './signOutAction';
import {
  PROFILE_COMPLETION_STATUS,
  TEMP_USER_PROFILE_ANSWER,
  UPDATE_USER_PROFILE,
  UPDATE_USER_PROFILE_LOADING,
  USER_UPDATED
} from './types';

export const updateUserProfileAction = (values: any) => async (dispatch: AppDispatch) => {
  dispatch({
    type: UPDATE_USER_PROFILE_LOADING,
    payload: true
  });

  const {
    success,
    status,
    data: { profile }
  } = await patchUser(values);

  if (success) {
    dispatch({
      type: UPDATE_USER_PROFILE,
      payload: values
    });

    dispatch({
      success: true,
      type: USER_UPDATED,
      payload: { user: profile }
    });
  } else {
    if (status == 401) {
      return dispatch(signOutAction);
    }
    return { success, status };
  }
};

export const updateUserProfileStateAction = (values: any) => async (dispatch: AppDispatch) => {
  return dispatch({
    type: TEMP_USER_PROFILE_ANSWER,
    payload: values
  });
};

export const setUserprofileCompletionState = (status: boolean) => async (dispatch: AppDispatch) => {
  return dispatch({
    type: PROFILE_COMPLETION_STATUS,
    payload: status
  });
};
